export const ChartInfo = [
  {
    type: 1,
    ko: '전신병력 차트',
    en: 'Medical History Chart',
    route: '/medical-history-chart',
    name: '전신병력',
  },
  {
    type: 2,
    ko: '치과병력 차트',
    en: 'Dental History Chart',
    route: '/dental-history-chart',
    name: '치과병력',
  },
  {
    type: 3,
    ko: '구강위생관리 차트',
    en: 'Methods of oral hygiene Chart',
    route: '/methods-of-oral-hygiene-chart',
    name: '구강위생관리',
  },
  {
    type: 4,
    ko: '생징후 차트',
    en: 'Vital Sign Chart',
    route: '/vital-sign-chart',
    name: '생징후',
  },
  {
    type: 5,
    ko: '구강 외 · 내 검사 차트',
    en: 'Extra · intra-oral examination Chart',
    route: '/extra-intra-oral-examination-chart',
    name: '구강 외·내 검사',
  },
  {
    type: 6,
    ko: '치아검사 차트',
    en: 'Oral Examination Chart',
    route: '/oral-examination-chart',
    name: '치아검사',
  },
  {
    type: 7,
    ko: '구내미생물검사 차트',
    en: 'Oral microbial Examination Chart',
    route: '/oral-microbial-examination-chart',
    name: '구내미생물검사',
  },
  {
    type: 8,
    ko: '구내예방처치 차트',
    en: 'Preventive Dental Treatment Chart',
    route: '/preventive-dental-treatment-chart',
    name: '구내예방처치',
  },
  {
    type: 9,
    ko: '치주검사 차트',
    en: 'Periodontal Examination Chart',
    route: '/periodontal-examination-chart',
    name: '치주검사',
  },
  {
    type: 10,
    ko: '구강사진(DSLR) 차트',
    en: 'Oral Photo (DSLR) Chart',
    route: '/dslr-chart',
    name: '구강사진(DSLR)',
  },
  {
    type: 11,
    ko: '구강사진 차트',
    en: 'Oral Photo (Intra-Oral Camera) Chart',
    route: '/intra-oral-camera-chart',
    name: '구강사진',
  },
  {
    type: 12,
    ko: '치면세균막 검사 차트',
    en: `Plaque Control_O'Leary Plaque Record Chart`,
    route: '/plaque-control-record-chart',
    name: '치면세균막검사',
  },
  {
    type: 13,
    ko: '진단모델 차트',
    en: 'Study Model Chart',
    route: '/study-model-chart',
    name: '진단모델',
  },
  {
    type: 14,
    ko: '치위생수행 차트',
    en: 'DH Implementation Chart',
    route: '/dh-implementation-chart',
    name: '치위생수행',
  },
  {
    type: 15,
    ko: '치위생진단·계획·평가 차트',
    en: 'DH Diagnosis · Plan · Evaluation Chart',
    route: '/dh-diagnosis-plan-evaluation-chart',
    name: '치위생진단·계획·평가',
  },
  {
    type: 16,
    ko: '대상자별 구강보건교육 자료',
    en: 'Oral health education data for each subject',
    route: '/oral-health-education-data-chart',
    name: '구강보건교육',
  },
];
